var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default"),_vm._v(" "),_c('FileList',{attrs:{"auctionId":_vm.auctionId,"files":_vm.files,"deleteCallback":_vm.removeFile,"mutable":_vm.mutable,"loading":_vm.loading > 0}}),_vm._v(" "),(_vm.mutable)?_c('FileUpload',{attrs:{"auctionId":_vm.auctionId,"uploadCallback":_vm.addFile,"usecase":_vm.usecase}}):_vm._e()],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4debf860","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/FileBox.vue
// module id = onPc
// module chunks = 1